// removed by extract-text-webpack-plugin
module.exports = {"loadMore":"c-OrderHistoryList__loadMore","wrapper":"c-OrderHistoryList__wrapper"};